import { useMemo } from 'react';
import { areColorsLowContrast, DEFAULT_MIN_CONTRAST_RATIO } from 'cards/util/contrast';

// Returns false if the specified foreground color/s is low contrast against the background color
export const useLowContrastCheck = (
  background: string | null,
  foreground: string | string[] | undefined,
  ratio: number = DEFAULT_MIN_CONTRAST_RATIO
): boolean => {
  const isLowContrast = useMemo(() => areColorsLowContrast(background, foreground, ratio), [
    background,
    foreground,
    ratio,
  ]);

  return isLowContrast;
};
